import { render, staticRenderFns } from "./PTW.vue?vue&type=template&id=16a10ad8&scoped=true"
import script from "./PTW.vue?vue&type=script&lang=js"
export * from "./PTW.vue?vue&type=script&lang=js"
import style0 from "./PTW.vue?vue&type=style&index=0&id=16a10ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a10ad8",
  null
  
)

export default component.exports